import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
export default {
  name: 'self_diagnosis_symptom',
  props: {
    breed: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      pageConfig: {
        editPageName: '选择症状',
        queryFunName: 'breedJoinDiseasesQueryJoinDiseasesAndDiseasesCategory',
        queryDiseasesFunName: 'diseasesSelfDiagnose',
        dicTreeFunName: 'dictionaryCache'
      },
      dicData: {
        typeUpperCode: 'Fishery_Symptom_Type',
        configTypes: [],
        configTypeOptions: {},
        configTypeLabels: {}
      },
      symptomId: '',
      checked: [],
      list: [],
      tip_show: false,
      result: {}
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$api[this.pageConfig.dicTreeFunName](this.dicData.typeUpperCode).then(/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(res) {
        var _iterator, _step, item;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!res.data) {
                _context.next = 6;
                break;
              }
              _this.dicData.configTypes = res.data;
              _iterator = _createForOfIteratorHelper(res.data);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  item = _step.value;
                  // this.$set(this.dicData.configTypeOptions,item.code,[])
                  _this.$set(_this.dicData.configTypeLabels, item.code, item.name);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              _context.next = 6;
              return _this.query();
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  },
  watch: {
    checked: function checked(to) {
      if (!to.length) {
        this.$emit('child-symptom-sel');
      }
    }
  },
  methods: {
    query: function query() {
      var _this2 = this;
      this.$api[this.pageConfig.queryFunName]({
        page: 1,
        limit: -1,
        breedId: this.breed.id
      }).then(function (res) {
        var _iterator2 = _createForOfIteratorHelper(res.data),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            var _iterator3 = _createForOfIteratorHelper(item.diseasesSymptoms),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var opt = _step3.value;
                if (!_this2.dicData.configTypeOptions[opt.diseasesSymptomType]) {
                  _this2.$set(_this2.dicData.configTypeOptions, opt.diseasesSymptomType, []);
                }
                _this2.dicData.configTypeOptions[opt.diseasesSymptomType].push(opt);
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        console.log('this.dicData.configTypeOptions', _this2.dicData.configTypeOptions);
      });
    },
    sel: function sel() {
      var _this3 = this;
      if (!this.checked.length) {
        this.$message.info('请先选择症状');
        return;
      }
      this.$emit('child-symptom-sel', true);
      this.$api[this.pageConfig.queryDiseasesFunName](this.breed.id, {
        symptomIds: this.checked.toString()
      }).then(function (res) {
        _this3.list = res.data;
      });
    },
    back: function back() {
      this.$emit('child-symptom-back');
    },
    reset: function reset() {
      this.checked = [];
      this.list = [];
    },
    lookClick: function lookClick(val) {
      this.tip_show = true;
      this.result = val;
    }
  }
};